import { render, staticRenderFns } from "./TermPicker.vue?vue&type=template&id=564339ab"
import script from "./TermPicker.vue?vue&type=script&lang=js"
export * from "./TermPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports